import { render, staticRenderFns } from "./CoffeeOrderList.vue?vue&type=template&id=313bd39b&scoped=true"
import script from "./CoffeeOrderList.vue?vue&type=script&lang=js"
export * from "./CoffeeOrderList.vue?vue&type=script&lang=js"
import style0 from "./CoffeeOrderList.vue?vue&type=style&index=0&id=313bd39b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313bd39b",
  null
  
)

export default component.exports